/**
 * Réglages applicatifs stockés localement sur l'appareil (IndexedDB via
 * StorageService) — jamais transmis au backend.
 */
export interface AppSettings {
  /**
   * Affiche le bouton « changer de caméra » dans le scanner (web). Désactivé par
   * défaut ; utile comme repli quand la sélection auto tombe sur la mauvaise
   * lentille (ex. certains Samsung à caméras multiples).
   */
  showManualCameraSwitch: boolean;
}

export const DEFAULT_APP_SETTINGS: AppSettings = {
  showManualCameraSwitch: false,
};
